import React from 'react';

interface BrokenIconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const BrokenIcon = ({ fill = 'black', height = 12, width = 12 }: BrokenIconProps) => (
    <svg width={width} height={height} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            fill={fill}
            d="M6 12C2.69156 12 0 9.30844 0 6C0 2.69156 2.69156 0 6 0C9.30844 0 12 2.69156 12 6C12 9.30844 9.30844 12 6 12ZM6 0.857117C3.16425 0.857117 0.857117 3.16425 0.857117 6C0.857117 8.83575 3.16425 11.1429 6 11.1429C8.83575 11.1429 11.1429 8.83575 11.1429 6C11.1429 3.16425 8.83575 0.857117 6 0.857117Z"
        />
        <path
            fill={fill}
            d="M8.14289 8.57141C8.03321 8.57141 7.92353 8.52958 7.83985 8.4458L3.55418 4.16013C3.38673 3.99268 3.38673 3.7215 3.55418 3.55414C3.72153 3.38678 3.99281 3.38669 4.16016 3.55414L8.44584 7.83982C8.61329 8.00727 8.61329 8.27845 8.44584 8.4458C8.36216 8.52958 8.25257 8.57141 8.14289 8.57141Z"
        />
        <path
            fill={fill}
            d="M3.85712 8.57145C3.74744 8.57145 3.63786 8.52961 3.55418 8.44584C3.38673 8.27848 3.38673 8.00721 3.55418 7.83985L7.83985 3.55418C8.0073 3.38673 8.27848 3.38673 8.44584 3.55418C8.6132 3.72153 8.61329 3.99281 8.44584 4.16016L4.16016 8.44584C4.07648 8.52961 3.9668 8.57145 3.85712 8.57145Z"
        />
    </svg>
);
